import React from 'react';
import moment from 'moment';

import styles from './styles.scss';
import {Link} from "react-router-dom";

export default class Footer extends React.Component {
    render() {
        return (
            <footer className={styles['footer']} role="contentinfo">

                <div className={styles['footer-content']}>
                    <div className={styles['link-sections']}>
                        <nav className={styles['panel']}>

                            <ul>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.rheglobal.com/consulting">
                                        Consulting
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.rheglobal.com/news">
                                        News
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="http://training.rheglobal.com">
                                        Training
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <nav className={styles['panel']}>

                            <ul>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.thenoiseapp.com">
                                        The Noise App
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.riams.org">
                                        RIAMS
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.whitedocs.com">
                                        Whitedocs
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <nav className={styles['panel']}>

                            <ul>
                                <li>
                                    <a className={styles['footer-link']} href="https://twitter.com/rheuk">
                                        Twitter
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="https://www.facebook.com/RHEnvironmental">
                                        Facebook
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href="https://www.linkedin.com/company/2307240">
                                        LinkedIn
                                    </a>
                                </li>
                            </ul>

                        </nav>

                        <nav className={styles['panel']}>

                            <ul>
                                <li>
                                    <a className={styles['footer-link']} href="https://www.rheglobal.com/copyright">
                                        Copyright
                                    </a>
                                </li>
                                <li>
                                    <a className={styles['footer-link']} href={`/accessibility-statement/${config.service_id}`}>
                                        Accessibility
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <nav className={styles['panel']}>

                            <ul>
                                <li>
                                    <a className={styles['footer-link']} href="http://www.rheglobal.com/contact">
                                        Contact
                                    </a>
                                </li>
                                <li>
                                    <Link className={styles['footer-link']} to={"/support"}>
                                        Support
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div className={styles['copyright']}>
                        <img alt="RHE logo" className={styles['rhe-logo']} src="/images/logos/rhe_logo_light.png" />

                        <div className={styles['copyright-text']}>
                            <span>© RH Environmental Ltd</span>
                            <br/>
                            <span>Trading as RHE Global</span>
                            <br/>
                            <span>{moment().format('YYYY')} All Rights Reserved</span>
                        </div>
                    </div>
                </div>

            </footer>
        );
    }
}
